import type { SearchFiltersSchema } from "@/lib/api/model";
import { SCOPE_OPTIONS } from "./filter-options";

export type FilterScope = "c" | "p" | "cp";

export function scopeLabel(scope: FilterScope): string {
  return (SCOPE_OPTIONS.find((o) => o.value === scope) ?? SCOPE_OPTIONS[1]).label;
}

export function resolveItemScope(
  scope: FilterScope | null | undefined,
  fallback: FilterScope | null | undefined,
): FilterScope {
  return scope ?? fallback ?? "cp";
}

/**
 * Scope a funding-stage chip without its own `scope` falls back to. Saved
 * searches from before per-chip scopes carry the retired section-level
 * `funding_scope` (any/current/historical); the backend honors it for such
 * chips, so the chip must display the same thing.
 */
export function legacyFundingStageScope(
  f: Pick<SearchFiltersSchema, "funding_scope" | "funding_filter_type">,
): FilterScope {
  if (f.funding_scope === "current") return "c";
  if (f.funding_scope === "historical") return "p";
  return f.funding_filter_type ?? "cp";
}

/** Pins each item's effective scope so the section-level fallback can be dropped. */
export function fillItemScopes<T extends { scope?: FilterScope | null }>(
  items: T[],
  fallback: FilterScope,
): T[] {
  return items.map((item) => (item.scope ? item : { ...item, scope: fallback }));
}
